import ZapIcon from 'assets/icons/zap.svg'
import { P } from 'components'
import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import LoadingV2 from 'components/LoadingV2'
import PMBModalRemove from 'components/PMBModalRemove'
import { PMBFormatDate } from 'helpers'
import { useSellerConfirmMutation } from 'features/private-views/approval/approvalApiSlice'
import { useFetchWarehousesQuery } from 'features/private-views/transfer-inventory/transferInventoryApiSlice'
import PMBSelect from 'components/PMBSelect'
import usePartialUpload from 'hooks/usePartialUpload'
import { useSnackbar } from 'notistack'
import { setTotal } from 'private-views/transactions/commodityPurchaseSlice'
import { useMemo, useRef, useState } from 'react'
import { Check, ChevronDown, ChevronUp, Edit, Printer } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Button, Card, CardBody, Col, Collapse, Row } from 'reactstrap'
import {
  URL_FULFILMENT_REPORT,
  URL_LIST_TRANSACTIONS,
  URL_ORDER_ADJUSTMENT,
  URL_TRANSACTION_QR_PRINT,
} from 'utils/pathUrl'
import { postConfirmTransaction } from '../dashboardAction'
import {
  useConfirmAdjustmentMutation,
  useFetchAdjustmentBySellerQuery,
  useFetchTransactionAdjustmentQuery,
  useFetchTransactionByIdQuery,
  useFetchTransactionNoteQuery,
  useRejectTransactionMutation,
  useSellerConfirmPaymentCodMutation,
  useSellerPaymentOnBehalfMutation,
} from '../dashboardApiSlice'
import ModalChoosePayment from './ModalChoosePayment'
import ModalSellerApproveConfirm from './ModalSellerApproveConfirm'
import ModalSellerConfirmTrx from './ModalSellerConfirmTrx'
import ModalSellerRejectConfirm from './ModalSellerRejectConfirm'
import ModalTransactionNote from './ModalTransactionNote'
import DetailOrderSection from './Sections/DetailOrderSection'
import DownloadDocumentsSection from './Sections/DownloadDocumentsSection'
import HeaderSection from './Sections/HeaderSection'
import HistoryTransactionSection from './Sections/HistoryTransactionSection'
import LaporanKetelusuranSection from './Sections/LaporanKetelusuranSection'
import TransactionInformation from './Sections/TransactionInformation'
import SidebarDetailPayment from './SidebarDetailPayment'
import './styles.css'
import ModalSellerConfirmPayment from './ModalSellerConfirmPayment'
import ModalSellerPaymentOnBehalf from './ModalSellerPaymentOnBehalf'
import ModalEditNoTrx from './ModalEditNoTrx'
import ModalEditProject from './ModalEditProject'
import ModalOriginalOrder from './ModalOriginalOrder'
import ModalFulfillmentResult from './ModalFulfillmentResult'
import { toggleModalNoTrx, toggleModalEdithProject } from '../dashboardSlice'
import moment from 'moment-timezone'

const DetailTransaction = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const webcamRef = useRef(null)
  const dispatch = useDispatch()
  const { uploadFile } = usePartialUpload()

  const { ownerData, profile, balance, modalEditNoTrx, modalEdithProject } = useSelector((s) => s.dashboard)

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const transactionType = searchParams.get('type')

  const dataState = location.state

  const [isOpenSidebar, setIsOpenSidebar] = useState(false)
  const [isModalPayment, setIsModalPayment] = useState(false)
  const [isNoteModalOpen, setIsNoteModalOpen] = useState(false)
  const [isNoteModalOpenEdit, setIsNoteModalOpenEdit] = useState(false)
  const [isChangeInstantPayment, setIsChangeInstantPayment] = useState(false)
  const [isRejectTransaction, setIsRejectTransaction] = useState(false)
  const [isModalConfirmAdjustment, setIsModalConfirmAdjustment] =
    useState(false)
  const [isModalSellerConfirm, setIsModalSellerConfirm] = useState(false)
  const [isModalSellerRejectConfirm, setIsModalSellerRejectConfirm] =
    useState(false)
  // State for COD seller confirm payment
  const [isModalSellerConfirmPayment, setIsModalSellerConfirmPayment] =
    useState(false)
  const [isLoadingSellerConfirmPayment, setIsLoadingSellerConfirmPayment] =
    useState(false)
  const [isModalSellerPayment, setIsModalSellerPayment] = useState(false)
  const [sellerPaymentOnBehalf, { isLoading: isLoadingSellerPayment }] =
    useSellerPaymentOnBehalfMutation()

  const [isLoadingCashPayment, setIsLoadingCashPayment] = useState(false)
  const [isAdjustBySeller, setIsAdjustBySeller] = useState(false)
  const [isModalOriginalOrderOpen, setIsModalOriginalOrderOpen] = useState(false)
  const [isModalFulfillmentOpen, setIsModalFulfillmentOpen] = useState(false)
  const [showConfirmTransactionBySeller, setShowConfirmTransactionBySeller] =
    useState(false)
  const [isOtherInfoOpen, setIsOtherInfoOpen] = useState(false)
  const toggleSellerConfirmTrx = () =>
    setShowConfirmTransactionBySeller(!showConfirmTransactionBySeller)

  const { serviceProvision } = useSelector((s) => s.auth)

  const toggleSidebar = () => setIsOpenSidebar((prev) => !prev)

  const {
    data,
    isLoading,
    refetch: refetchTransactionById,
  } = useFetchTransactionByIdQuery({
    id,
    escrowpaymentId: dataState?.escrowpaymentId,
    tradeshortcutId: dataState?.tradeshortcutId,
  })
  let transaction = data
  const isTransactionExpired =
    transaction?.escrowpayment?.expiredDate &&
    transaction?.escrowpayment?.status === 'NEED_CONFIRM_BY_SELLER' &&
    moment(transaction.escrowpayment.expiredDate).isBefore(moment())

  if (isTransactionExpired && transaction) {
    transaction = { ...transaction, status: 'Expired' }
  }
  const isBuyer = transaction
    ? Number(transaction?.buyerDetail?.userId) === Number(ownerData?.userId)
    : transactionType === 'BUY'

  const [sellerConfirmPaymentCod] = useSellerConfirmPaymentCodMutation()

  const escrowpaymentId = transaction?.escrowpaymentId
  const ownerPhoneNumber = ownerData?.phoneNumber

  const tradeshortcutId = !escrowpaymentId ? transaction?.id : undefined
  const mustAdjustment =
    transaction?.mustAdjustment ??
    transaction?.orderDetail?.mustAdjustment ??
    transaction?.escrowpayment?.mustAdjustment

  const sellerFillCreatedDate =
    transaction?.history?.sellerFillCreatedDate ??
    transaction?.sellerFillCreatedDate

  const isMustAdjustment = Boolean(mustAdjustment && sellerFillCreatedDate)

  // buyer-only "Konfirmasi Barang Sampai" card; seller-on-behalf never sees it, so its warehouse stays null
  const canBuyerConfirmArrival = Boolean(
    transaction?.escrowpayment?.status === 'ON_GOING' &&
    (transaction?.orderDetail?.type === 'BUY' || transactionType === 'BUY') &&
    !transaction?.orderDetail?.autoRelease &&
    ownerData?.userId == transaction?.buyerDetail?.userId &&
    transaction?.status?.toLowerCase() !== 'menunggu konfirmasi pembayaran',
  )
  const [toWarehouse, setToWarehouse] = useState(null)
  const { data: warehouses, isFetching: isFetchingWarehouses } =
    useFetchWarehousesQuery(
      { isForFilter: 1 },
      { skip: !canBuyerConfirmArrival },
    )
  // BE (validateWarehouseTarget) only keeps a warehouse the logged-in user is a member of;
  // the null row (id null) carries the owner's userId, so only the owner sees it,
  // unless nothing else is left, then it is everyone's fallback
  const isLoginUser = (userId) => Number(userId) === Number(profile?.userId)
  const ownWarehouses = warehouses?.newData?.filter((w) =>
    w.id
      ? w.warehousemember?.some((m) => isLoginUser(m.userId))
      : isLoginUser(w.userId),
  )
  const warehouseOptions = ownWarehouses?.length
    ? ownWarehouses
    : warehouses?.newData?.filter((w) => !w.id)
  // remembered per user in this browser only; storage can throw (private mode), so fall back to the null warehouse
  const lastWarehouseKey = `PMB_lastToWarehouse-${profile?.userId}`
  let lastWarehouseId = null
  try {
    lastWarehouseId = localStorage.getItem(lastWarehouseKey)
  } catch (e) {
    // storage unavailable: keep the null warehouse default
  }
  // required field: remembered pick first, auto-pick when there is only one option, otherwise the user chooses
  const selectedWarehouse =
    toWarehouse ??
    warehouseOptions?.find((w) => w.id && String(w.id) === lastWarehouseId) ??
    (warehouseOptions?.length === 1 ? warehouseOptions[0] : null)
  const rememberWarehouse = () => {
    try {
      if (selectedWarehouse?.id)
        localStorage.setItem(lastWarehouseKey, String(selectedWarehouse.id))
      else localStorage.removeItem(lastWarehouseKey)
    } catch (e) {
      // storage unavailable: nothing to remember, confirm already succeeded
    }
  }

  const shouldFetchAdjustmentBySeller =
    transaction?.status === 'Diproses' &&
    !isBuyer &&
    serviceProvision?.confirmOnBehalfBuyer

  const {
    data: adjustmentBySellerData,
    isLoading: isLoadingAdjustmentBySeller,
    isError: isErrorAdjustmentBySeller,
  } = useFetchAdjustmentBySellerQuery(
    { escrowpaymentId },
    { skip: !shouldFetchAdjustmentBySeller },
  )

  const {
    data: transactionNoteData,
    isLoading: isTransactionNoteLoading,
    refetch,
  } = useFetchTransactionNoteQuery(
    {
      type: transactionType,
      escrowpaymentId,
      tradeshortcutId,
    },
    { skip: !transactionType || !(escrowpaymentId || tradeshortcutId) },
  )

  const [
    rejectTransaction,
    { isLoading: isLoadingReject, isError, data: dataReject },
  ] = useRejectTransactionMutation()
  const [sellerConfirm, { isLoading: isLoadingConfirm }] =
    useSellerConfirmMutation()

  const [confirmAdjustment, { isLoading: isLoadingConfirmAdjustment }] =
    useConfirmAdjustmentMutation()

  // GET DATA TRANSACTION ADJUSTMENT (Skipped: invoice API is no longer fetched on DetailTransaction load)
  const {
    data: transactionAdjustmentData,
    isLoading: isTransactionAdjustmentLoading,
    refetch: refetchTransactionAdjustment,
  } = useFetchTransactionAdjustmentQuery(
    {
      escrowpaymentId,
      customerCode: ownerPhoneNumber,
    },
    { skip: true },
  )

  const activeAdjustmentData =
    transactionAdjustmentData || {
      adjustment: transaction?.adjustments || transaction?.adjustment,
    }

  const hasEmbeddedAdjustmentItem = useMemo(() => {
    const topItems =
      transaction?.adjustments?.adjustmentitems ||
      transaction?.adjustment?.adjustmentitems ||
      transaction?.adjustmentitems
    if (Array.isArray(topItems) && topItems.length > 0) {
      return true
    }
    const flatten = (items) => {
      if (!Array.isArray(items)) return []
      const res = []
      for (const node of items) {
        if (node?.groupLabel && Array.isArray(node?.items)) {
          res.push(...flatten(node.items))
        } else {
          res.push(node)
        }
      }
      return res
    }
    return flatten(transaction?.itemDetail).some(
      (item) => item?.adjustmentitem || item?.adjustmentItem || item?.adjustmentitems,
    )
  }, [transaction?.itemDetail, transaction?.adjustments, transaction?.adjustment, transaction?.adjustmentitems])

  const isAdjustment = Boolean(
    hasEmbeddedAdjustmentItem ||
    (activeAdjustmentData?.adjustment &&
      Object.keys(activeAdjustmentData.adjustment).length > 0 &&
      activeAdjustmentData?.adjustment?.status !== 'REJECTED'),
  )
  const isStatusAdjustmentRejected = Boolean(
    activeAdjustmentData?.adjustment &&
    activeAdjustmentData?.adjustment?.status === 'REJECTED',
  )

  const mergedTransactionAdjustmentData = useMemo(() => {
    const isTransactionAdjustmentValid =
      activeAdjustmentData?.adjustment?.status &&
      activeAdjustmentData.adjustment.status !== 'REJECTED'

    const shouldUseSellerData =
      transaction?.status === 'Diproses' &&
      !isBuyer &&
      serviceProvision?.confirmOnBehalfBuyer &&
      adjustmentBySellerData?.adjustmentitems?.length > 0

    if (isTransactionAdjustmentValid) {
      if (activeAdjustmentData.adjustment.status === 'APPROVED') {
        return activeAdjustmentData
      }

      if (!shouldUseSellerData) {
        return activeAdjustmentData
      }
    }

    const flattenItems = (items) => {
      if (!Array.isArray(items)) return []
      const res = []
      for (const node of items) {
        if (node?.groupLabel && Array.isArray(node?.items)) {
          res.push(...flattenItems(node.items))
        } else {
          res.push(node)
        }
      }
      return res
    }

    const allLeafItems = flattenItems(transaction?.itemDetail)
    const embeddedAdjustmentItems =
      Array.isArray(transaction?.adjustmentitems) && transaction.adjustmentitems.length > 0
        ? transaction.adjustmentitems
        : allLeafItems
            .map(
              (item) =>
                item?.adjustmentitem ||
                item?.adjustmentItem ||
                (Array.isArray(item?.adjustmentitems)
                  ? item.adjustmentitems[0]
                  : item?.adjustmentitems),
            )
            .filter(Boolean)

    // Fallback: pakai data dari seller, active adjustment, atau embedded adjustmentitem di itemDetail
    const adjustmentItems =
      adjustmentBySellerData?.adjustmentitems?.length > 0
        ? adjustmentBySellerData.adjustmentitems
        : isTransactionAdjustmentValid
          ? activeAdjustmentData.adjustment?.adjustmentitems || []
          : embeddedAdjustmentItems

    return {
      ...activeAdjustmentData,
      orderItems:
        (activeAdjustmentData?.orderItems || allLeafItems || [])?.map((inv, index) => {
          const matchedAdjustment = adjustmentItems?.[index] || inv.adjustmentitem
          const price = matchedAdjustment?.price ?? inv.price ?? 0
          const amount = matchedAdjustment?.amount ?? inv.amount ?? 0
          const totalPrice = price * amount

          return {
            id: inv.id,
            orderitemId: inv?.id || inv?.orderitemId,
            SKU: inv?.SKU,
            nameItem: inv?.nameItem,
            originalAmount: matchedAdjustment?.originalAmount ?? amount,
            originalPrice: matchedAdjustment?.originalPrice ?? price,
            originalTotal: matchedAdjustment?.originalTotalPrice ?? (totalPrice || 0),
            amount,
            price,
            totalPrice: totalPrice || 0,
            unit: inv.item?.unit || inv?.unit,
            newAmount: matchedAdjustment?.newAmount ?? amount,
            newPrice: matchedAdjustment?.newPrice ?? matchedAdjustment?.price ?? price,
            newTotalPrice:
              matchedAdjustment?.newTotalPrice ??
              (((matchedAdjustment?.newPrice ?? matchedAdjustment?.price ?? price) *
                (matchedAdjustment?.newAmount ?? amount)) || 0),
            priceAdjustment: matchedAdjustment?.priceAdjustment ?? 0,
            deleted: Boolean(matchedAdjustment?.deleted),
            newSellPriceBeforeVAT:
              matchedAdjustment?.newSellPriceBeforeVAT ??
              (((matchedAdjustment?.newPrice ?? matchedAdjustment?.price ?? price) *
                (matchedAdjustment?.newAmount ?? amount)) || 0),
            newSellPriceAfterVAT:
              matchedAdjustment?.newSellPriceAfterVAT ??
              (((matchedAdjustment?.newPrice ?? matchedAdjustment?.price ?? price) *
                (matchedAdjustment?.newAmount ?? amount)) || 0),
            snapshotVAT: matchedAdjustment?.snapshotVAT ?? null,
            createdAt: matchedAdjustment?.createdAt || new Date().toISOString(),
            updatedAt: matchedAdjustment?.updatedAt || new Date().toISOString(),
            adjustmentId: matchedAdjustment?.adjustmentId ?? null,
            inventories: inv.inventories,
          }
        }) || [],
      adjustment: {
        ...adjustmentItems?.[0],
        newAmount: adjustmentItems.reduce(
          (acc, item) =>
            acc + (item?.newAmount || 0) * (item?.newPrice || item?.price || 0),
          0,
        ),
        adjustmentitems: adjustmentItems.map((item) => ({
          id: item?.id || item?.orderitemId || null,
          originalAmount: item?.originalAmount ?? item?.amount ?? 0,
          originalPrice: item?.originalPrice ?? item?.price ?? 0,
          originalTotalPrice:
            item?.originalTotalPrice ??
            ((item?.originalPrice ?? item?.price ?? 0) *
            (item?.originalAmount ?? item?.amount ?? 0)),
          orderitemId: item?.orderitemId || item?.id || null,
          newAmount: item?.newAmount ?? item?.amount ?? 0,
          newPrice: item?.newPrice ?? item?.price ?? 0,
          newTotalPrice:
            item?.newTotalPrice ??
            ((item?.newPrice ?? item?.price ?? 0) *
            (item?.newAmount ?? item?.amount ?? 0)),
          priceAdjustment: item?.priceAdjustment ?? 0,
          deleted: item?.deleted ?? false,
          editType: item?.editType,
          causeOfChange: item?.causeOfChange,
          reason: item?.reason,
          newSellPriceBeforeVAT:
            item?.newSellPriceBeforeVAT ??
            ((item?.newPrice ?? item?.price ?? 0) *
            (item?.newAmount ?? item?.amount ?? 0)),
          newSellPriceAfterVAT:
            item?.newSellPriceAfterVAT ??
            ((item?.newPrice ?? item?.price ?? 0) *
            (item?.newAmount ?? item?.amount ?? 0)),
          snapshotVAT: item?.snapshotVAT ?? null,
          createdAt: item?.createdAt || new Date().toISOString(),
          updatedAt: item?.updatedAt || new Date().toISOString(),
          adjustmentId: item?.adjustmentId ?? null,
        })),
      },
    }
  }, [
    activeAdjustmentData,
    transaction,
    isBuyer,
    serviceProvision?.confirmOnBehalfBuyer,
    adjustmentBySellerData,
  ])

  // SHOW LOADING
  if (isLoading || isTransactionAdjustmentLoading) return <LoadingV2 />

  const togglePayment = () => {
    setIsModalPayment((prev) => !prev)
    setIsChangeInstantPayment(false)
  }

  const toggleNoteModal = () => {
    setIsNoteModalOpen((prev) => !prev)
    if (isNoteModalOpenEdit) {
      setIsNoteModalOpenEdit(false)
    }
  }

  const handleRefetch = () => {
    refetch()
  }

  const isCreator =
    transaction?.orderDetail?.type === 'BUY'
      ? String(ownerData?.userId) === transaction?.buyerDetail?.userId
      : String(ownerData?.userId) === transaction?.sellerDetail?.userId

  const sellerUserId = Number(transaction?.sellerDetail?.userId)
  const buyerUserId = Number(transaction?.buyerDetail?.userId)
  const ownerUserId = Number(ownerData?.userId)

  const isSellerShowCard =
    transaction?.status === 'Menunggu Pembayaran Pembeli' &&
    !escrowpaymentId &&
    // !isBuyer &&
    !transaction?.buyerDetail?.mustVerify &&
    Number(transaction?.buyerDetail?.userId) === ownerUserId

  const isBuyerShowCard =
    transaction?.status === 'Menunggu Pembayaran Pembeli' &&
    !escrowpaymentId &&
    isBuyer

  const isShowCardPaymentandReject = isSellerShowCard || isBuyerShowCard

  const onHandleOpenCloseModalReject = () => {
    setIsRejectTransaction((prev) => !prev)
  }

  const onRejectTransaction = async (id) => {
    try {
      if (!id) {
        enqueueSnackbar('Transaksi gagal ditolak!', {
          variant: 'error',
        })

        return
      }

      const res = await rejectTransaction({ id }).unwrap()

      if (res) {
        enqueueSnackbar('Transaksi berhasil ditolak!', {
          variant: 'success',
        })

        refetchTransactionById()
        handleRefetch()
        onHandleOpenCloseModalReject()
      }
    } catch (error) {
      console.warn(error)
      enqueueSnackbar(
        error?.data?.meta?.message ||
        error?.data?.message ||
        error?.message ||
        'Transaksi gagal ditolak!',
        {
          variant: 'error',
        },
      )

      onHandleOpenCloseModalReject()
    }
  }

  const handleConfirmTransaction = async (confirmValue) => {
    if (!escrowpaymentId && !transaction?.tradeshortcutId) {
      enqueueSnackbar('ID transaksi tidak valid', { variant: 'error' })
      return
    }
    let payload = {
      confirm: confirmValue,
    }

    if (transaction?.approvedAt === null) {
      if (transaction?.tradeshortcutId) {
        payload['tradeshortcutId'] = transaction?.tradeshortcutId
      } else {
        payload['escrowpaymentId'] = escrowpaymentId
      }
    } else {
      payload['escrowpaymentId'] = escrowpaymentId
    }

    try {
      await sellerConfirm(payload).unwrap()

      enqueueSnackbar(
        confirmValue === 1
          ? 'Transaksi berhasil diterima!'
          : 'Transaksi berhasil ditolak!',
        { variant: 'success' },
      )
      refetchTransactionById()
    } catch (error) {
      enqueueSnackbar(error?.data?.message || 'Terjadi kesalahan, coba lagi', {
        variant: 'error',
      })
    }
  }

  const onHandleOpenCloseModalConfirmAdjustment = () => {
    setIsModalConfirmAdjustment((prev) => !prev)
  }

  const onHandleOpenCloseModalSellerConfirm = () => {
    setIsModalSellerConfirm((prev) => !prev)
  }

  const onHandleOpenCloseModalSellerRejectConfirm = () => {
    setIsModalSellerRejectConfirm((prev) => !prev)
  }

  const handleConfirmAdjustment = async (isAgree) => {
    try {
      const payload = {
        escrowpaymentId: escrowpaymentId,
        customerCode: ownerPhoneNumber,
        agree: isAgree?.toString(),
      }

      const response = await confirmAdjustment(payload).unwrap()

      if (response?.id || response) {
        // RESET MODAL FIRST
        setIsModalConfirmAdjustment(false)
        setIsModalSellerConfirm(false)
        setIsModalSellerRejectConfirm(false)

        enqueueSnackbar(
          isAgree
            ? 'Penyesuaian pesanan berhasil diterima.'
            : 'Penyesuaian pesanan berhasil ditolak.',
          {
            variant: 'success',
          },
        )

        try {
          refetchTransactionById?.()
        } catch (err) {
          console.error('Error refetching transaction:', err)
        }
      }
    } catch (error) {
      const errorMessage =
        (typeof error === 'string' ? error : null) ||
        error?.data?.message ||
        error?.message ||
        'Terjadi kesalahan saat mengkonfirmasi penyesuaian'
      enqueueSnackbar(errorMessage, {
        variant: 'error',
      })
    }
  }

  const isDispute =
    transaction?.escrowpayment?.status?.toLowerCase() === 'dispute'

  // CASH PAYMENT
  const handleConfirmCashPayment = async () => {
    try {
      setIsLoadingCashPayment(true)
      const payload = {
        escrowPaymentId: escrowpaymentId,
        useDisbursementpricingId: 0, // COZ CASH PAYMENT
        ...(selectedWarehouse?.id && {
          toWarehouseTarget: selectedWarehouse.id,
        }),
      }

      const res = await dispatch(postConfirmTransaction({ payload }))

      if (res?.payload?.status === 200 || res?.payload?.id) {
        rememberWarehouse()
        refetchTransactionById()
        handleRefetch()

        enqueueSnackbar(
          'Konfirmasi barang sampai berhasil. Transaksi selesai.',
          {
            variant: 'success',
          },
        )
      } else {
        throw res
      }
    } catch (error) {
      console.warn(error)
      setIsLoadingCashPayment(false)
      enqueueSnackbar(
        error?.payload ?? error?.message ?? error?.error?.message,
        {
          variant: 'error',
        },
      )
    } finally {
      setIsLoadingCashPayment(false)
    }
  }

  // COD Seller Confirm Payment
  const handleSellerConfirmPayment = async () => {
    setIsLoadingSellerConfirmPayment(true)
    try {
      await sellerConfirmPaymentCod({ escrowpaymentId }).unwrap()
      enqueueSnackbar('Pembayaran pembeli berhasil dikonfirmasi!', {
        variant: 'success',
      })
      setIsModalSellerConfirmPayment(false)
      refetchTransactionById()
    } catch (error) {
      enqueueSnackbar(error?.data?.message || 'Gagal konfirmasi pembayaran', {
        variant: 'error',
      })
    } finally {
      setIsLoadingSellerConfirmPayment(false)
    }
  }

  // Seller Payment On Behalf of Buyer
  const handleSellerPaymentOnBehalf = async () => {
    try {
      const selectedMethod = transaction?.sellerContinuePayment?.methods?.[0]
      const payload = {
        id: transaction?.tradeshortcutId || transaction?.id,
        usePayable: selectedMethod?.usePayable ?? true,
        useProofOfPayment: selectedMethod?.useProofOfPayment ?? false,
        paymentTime: null,
        loanDays: null,
        creditRequested: null,
      }
      await sellerPaymentOnBehalf(payload).unwrap()
      enqueueSnackbar('Pembayaran atas nama pembeli berhasil!', {
        variant: 'success',
      })
      setIsModalSellerPayment(false)
      refetchTransactionById()
    } catch (error) {
      enqueueSnackbar(
        error?.data?.message || 'Gagal melakukan pembayaran atas nama pembeli',
        {
          variant: 'error',
        },
      )
    }
  }

  // PAYMENT METHOD FOR DOWNLOAD TRANSACTION DETAIL PDF
  let paymentMethod = transaction?.paymentMethod || '-'

  if (!transaction?.paymentMethod && transaction?.status === 'Menunggu Pembayaran Pembeli') {
    paymentMethod = '-'
  } else if (
    (transaction?.orderDetail?.useProofOfpayment ||
      transaction?.orderDetail?.useProofOfPayment) &&
    transaction?.orderDetail?.paymentTime
  ) {
    paymentMethod = 'COD'
  } else if (
    transaction?.orderDetail?.useProofOfpayment ||
    transaction?.orderDetail?.useProofOfPayment
  ) {
    paymentMethod = 'Tunai'
  } else if (
    transaction?.orderDetail?.usePayable ||
    transaction?.escrowpayment?.usePayable
  ) {
    paymentMethod = 'Kredit Penjual'
  } else if (
    transaction?.sellerDetail?.disbursementViaAgent === true ||
    transaction?.sellerDetail?.disbursementViaAgent === 'true'
  ) {
    paymentMethod =
      'Pembayaran Melalui Agen' +
      (transaction?.creditRequested ? ' + Talangin' : ' + Uang Belanja')
  } else if (!transaction?.creditRequested) {
    paymentMethod = 'Uang Belanja'
  } else {
    paymentMethod = 'Talangin'
  }

  // Show button only for seller, status Diproses, COD (useProofOfPayment), and escrowpaymentId exists
  const showSellerConfirmPaymentButton =
    !isBuyer &&
    transaction?.status === 'Menunggu Konfirmasi Pembayaran' &&
    (transaction?.orderDetail?.useProofOfPayment ||
      transaction?.orderDetail?.useProofOfpayment) &&
    transaction?.orderDetail?.paymentTime

  const canSellerConfirmOnBehalfBuyer =
    !isBuyer && serviceProvision?.confirmOnBehalfBuyer

  const isAdjustmentBySeller = Boolean(
    adjustmentBySellerData?.adjustmentitems?.length &&
    transactionAdjustmentData?.adjustment?.status !== 'APPROVED',
  )

  const isSellerAdjustmentTimeline = Boolean(
    isAdjustmentBySeller ||
    (transaction?.orderDetail?.type === 'SELL' &&
      transaction?.history?.disputeDate),
  )

  const isConfirmOnBehalfBuyer = Boolean(
    canSellerConfirmOnBehalfBuyer && transaction?.history?.releaseDate,
  )

  const shouldHighlightAdjustedValues = Boolean(
    isDispute &&
    ownerUserId !== buyerUserId &&
    activeAdjustmentData?.adjustment?.status !== 'APPROVED',
  )

  const shouldShowAdjustmentResponseCard =
    isDispute && ownerUserId !== buyerUserId

  const shouldShowSellerConfirmOnBehalfCard =
    canSellerConfirmOnBehalfBuyer &&
    !shouldShowAdjustmentResponseCard &&
    transaction?.status === 'Diproses'

  const shouldShowSellerAdjustmentWarning = Boolean(
    transaction?.orderDetail?.type === 'SELL' &&
    transaction?.status === 'Diproses' &&
    activeAdjustmentData?.adjustment?.status !== 'APPROVED' &&
    transaction?.history?.disputeDate,
  )

  const isUsePayable = Boolean(
    transaction?.orderDetail?.usePayable
  )

  const hasEscrowPaymentId = Boolean(
    transaction?.escrowpayment?.id
  )

  const isHideTolakButton = isUsePayable && hasEscrowPaymentId

  return (
    // <div className="container mt-4">
    <div className="w-100 px-3">
      {/* Breadcrumb */}
      <div className="mt-3">
        {dataState?.isList ? (
          <BreadCrumbs
            breadCrumbActive={`Detail ${isBuyer ? 'Pembelian' : 'Penjualan'}
            `}
            breadCrumbParent={`Daftar Transaksi`}
            breadCrumbParentLink={URL_LIST_TRANSACTIONS}
          />
        ) : (
          <BreadCrumbs
            breadCrumbActive={`Detail ${isBuyer ? 'Pembelian' : 'Penjualan'}`}
          />
        )}
      </div>

      {/* MODAL REJECT TRANSACTION  */}
      <PMBModalRemove
        isOpen={isRejectTransaction}
        onClose={() => onHandleOpenCloseModalReject()}
        title={`Tolak transaksi`}
        dataId={transaction?.id}
        desc={`Apakah Anda yakin ingin menolak transaksi dari ${transaction?.sellerDetail?.fullName ?? '-'}?`}
        isLoading={isLoadingReject}
        onRemoveData={(id) => {
          onRejectTransaction(id)
        }}
        buttonTitle="Tolak"
      />
      {/* END MODAL REJECT TRANSACTION  */}

      {/* MODAL PAYMENT */}
      <ModalChoosePayment
        isOpen={isModalPayment}
        toggle={togglePayment}
        transaction={transaction}
        refetchTransactionById={refetchTransactionById}
        isChangeInstantPayment={isChangeInstantPayment}
        toWarehouseTarget={selectedWarehouse?.id}
        onConfirmed={rememberWarehouse}
      />
      {/* END MODAL PAYMENT */}

      {/* MODAL ADJUSTMENT CONFIRM */}
      {/* <ModalConfirmAdjustment
        isOpen={isModalConfirmAdjustment}
        toggle={onHandleOpenCloseModalConfirmAdjustment}
        escrowpaymentId={escrowpaymentId}
        ownerPhoneNumber={ownerPhoneNumber}
        TransactionType={transactionType}
        imageUser={
          isBuyer
            ? transaction?.sellerOrBuyAvatar
            : transaction?.sellerOrBuyAvatar
        }
        sellerName={
          isBuyer
            ? transaction?.sellerDetail?.fullName
            : transaction?.buyerDetail?.fullName
        }
        isAdjustBySeller={isAdjustBySeller}
        adjustFufilmentData={
          adjustmentBySellerData?.adjustmentitems?.length &&
          !transactionAdjustmentData?.adjustment?.status !== 'APPROVED'
            ? adjustmentBySellerData?.adjustmentitems
            : null
        }
      /> */}
      {/* END MODAL ADJUSTMENT CONFIRM */}

      {/* SIDEBAR */}
      <SidebarDetailPayment
        isOpen={isOpenSidebar}
        toggle={toggleSidebar}
        row={transaction}
        isAdjustment={isAdjustment}
      />
      {/* END SIDEBAR */}

      {/* MODAL TRANSACTION NOTE */}
      <ModalTransactionNote
        open={isNoteModalOpen}
        toggle={toggleNoteModal}
        transactionNoteData={transactionNoteData}
        handleRefetch={handleRefetch}
        isEdit={isNoteModalOpenEdit}
      />
      {/* END MODAL TRANSACTION NOTE */}
      <ModalSellerConfirmTrx
        showConfirmTransactionBySeller={showConfirmTransactionBySeller}
        toggle={toggleSellerConfirmTrx}
        transaction={transaction}
        handleRefetch={handleRefetch}
        refetchTransactionById={refetchTransactionById}
        refetchTransactionAdjustment={refetchTransactionAdjustment}
      />

      <ModalEditNoTrx
        isOpen={modalEditNoTrx}
        toggle={() => dispatch(toggleModalNoTrx())}
        data={transaction}
        refetch={refetchTransactionById}
      />

      <ModalEditProject
        isOpen={modalEdithProject}
        toggle={() => dispatch(toggleModalEdithProject())}
        data={transaction}
        refetch={refetchTransactionById}
      />

      <ModalOriginalOrder
        isOpen={isModalOriginalOrderOpen}
        toggle={() => setIsModalOriginalOrderOpen((prev) => !prev)}
        transaction={transaction}
      />

      <ModalFulfillmentResult
        isOpen={isModalFulfillmentOpen}
        toggle={() => setIsModalFulfillmentOpen((prev) => !prev)}
        transaction={transaction}
      />

      <ModalSellerPaymentOnBehalf
        isOpen={isModalSellerPayment}
        toggle={() => setIsModalSellerPayment(false)}
        onConfirm={handleSellerPaymentOnBehalf}
        isLoading={isLoadingSellerPayment}
        methods={transaction?.sellerContinuePayment?.methods}
      />

      {/* HEADER */}
      <HeaderSection
        transaction={transaction}
        isBuyer={isBuyer}
        isCreator={isCreator}
        refetch={refetchTransactionById}
      />
      {/* END HEADER */}

      {isTransactionExpired && (
        <Card
          className="shadow-sm text-center mb-3"
          style={{
            backgroundColor: '#FEF2F2',
            border: '1px solid #FECACA !important',
          }}
        >
          <CardBody>
            <p className="text-danger fw-medium m-0">
              Transaksi ini sudah kedaluwarsa (Expired)
            </p>
          </CardBody>
        </Card>
      )}

      <Row>
        {/* LEFT COLUMN  */}
        <Col md="5">
          {transaction?.status === 'Selesai' &&
            transaction?.orderDetail?.autoRelease && (
              <Card
                className="shadow-sm text-center mb-3"
                style={{
                  backgroundColor: '#ECFAFF',
                  border: '1px solid #8ABBCC !important',
                }}
              >
                <CardBody>
                  <P size="default" color="#101828">
                    Barang sudah diterima sebelum transaksi ini dibuat
                  </P>
                </CardBody>
              </Card>
            )}

          {transaction?.status === 'Menunggu Proses Penjual' &&
            ownerUserId != buyerUserId &&
            !transaction?.rejectedAt ? (
            <Card
              className="shadow-sm text-center mb-3"
              style={{
                backgroundColor: '#ECFAFF',
                border: '1px solid #8ABBCC !important',
              }}
            >
              <CardBody>
                <p>
                  {transaction?.sellerProcessingExpired
                    ? 'Pesanan ini sudah expired dan tidak bisa dilanjutkan'
                    : serviceProvision?.sellerProcessing &&
                      (transaction?.escrowPaymentId ||
                        transaction?.escrowpaymentId ||
                        transaction?.escrowpayment?.id) &&
                      transaction?.orderDetail?.type === 'SELL'
                      ? 'Lakukan pemenuhan pesanan ini untuk melanjutkan transaksi'
                      : 'Terima pesanan ini untuk melanjutkan transaksi'}
                </p>
                <div style={{ display: 'flex', gap: '10px' }}>
                  {!isHideTolakButton && (
                    <Button
                      outline
                      color="primary"
                      size="sm"
                      style={{ flex: 1 }}
                      onClick={() => handleConfirmTransaction(0)}
                      className="btn-cancel"
                    >
                      Tolak
                    </Button>
                  )}
                  <CustomButton
                    disabled={transaction?.sellerProcessingExpired}
                    block
                    color="primary"
                    size="sm"
                    style={{ flex: 1 }}
                    onClick={() => {
                      if (
                        serviceProvision?.sellerProcessing &&
                        (transaction?.escrowPaymentId ||
                          transaction?.escrowpaymentId ||
                          transaction?.escrowpayment?.id) &&
                        transaction?.orderDetail?.type === 'SELL'
                      ) {
                        navigate(
                          `${URL_FULFILMENT_REPORT}/${transaction?.escrowpaymentId || transaction?.id}`,
                          {
                            state: { rowData: transaction },
                          },
                        )
                      } else {
                        handleConfirmTransaction(1)
                      }
                    }}
                  >
                    {serviceProvision?.sellerProcessing &&
                      (transaction?.escrowPaymentId ||
                        transaction?.escrowpaymentId ||
                        transaction?.escrowpayment?.id) &&
                      transaction?.orderDetail?.type === 'SELL'
                      ? 'Pemenuhan'
                      : 'Terima'}
                  </CustomButton>
                </div>
              </CardBody>
            </Card>
          ) : null}

          {/* DISPUTE*/}
          {/* MODAL ADJUSTMENT APPROVE CONFIRM */}
          <ModalSellerApproveConfirm
            isOpen={isModalSellerConfirm}
            toggle={onHandleOpenCloseModalSellerConfirm}
            onConfirm={() => handleConfirmAdjustment(true)}
            isLoading={isLoadingConfirmAdjustment}
          />
          {/* END MODAL ADJUSTMENT APPROVE CONFIRM */}

          {/* MODAL ADJUSTMENT REJECT CONFIRM */}
          <ModalSellerRejectConfirm
            isOpen={isModalSellerRejectConfirm}
            toggle={onHandleOpenCloseModalSellerRejectConfirm}
            onConfirm={() => handleConfirmAdjustment(false)}
            isLoading={isLoadingConfirmAdjustment}
          />
          {/* END MODAL ADJUSTMENT REJECT CONFIRM */}
          {/* SHOW AS SELLER */}
          {shouldShowAdjustmentResponseCard ? (
            <Card
              className="shadow-sm text-center mb-3"
              style={{
                backgroundColor: '#ECFAFF',
                border: '1px solid #8ABBCC !important',
              }}
            >
              <CardBody>
                <p>Pembeli mengajukan penyesuaian untuk transaksi ini</p>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <Button
                    outline
                    color="primary"
                    size="sm"
                    style={{ flex: 1 }}
                    onClick={onHandleOpenCloseModalSellerRejectConfirm}
                    className="btn-cancel"
                  >
                    Tolak
                  </Button>
                  <CustomButton
                    block
                    color="primary"
                    size="sm"
                    style={{ flex: 1 }}
                    onClick={onHandleOpenCloseModalSellerConfirm}
                  >
                    Terima
                  </CustomButton>
                </div>
              </CardBody>
            </Card>
          ) : null}
          {/* SHOW AS BUYER */}
          {isDispute && ownerUserId != sellerUserId && (
            <Card
              className="shadow-sm text-center mb-3"
              style={{
                backgroundColor: '#ECFAFF',
                border: '1px solid #8ABBCC !important',
              }}
            >
              <CardBody>
                <P size="default" color="#101828">
                  Konfirmasi bisa dilakukan setelah penjual menyetujui
                  penyesuaian yang Anda ajukan.
                </P>
              </CardBody>
            </Card>
          )}
          {/* END DISPUTE */}
          {/* INFO PEMBAYARAN */}
          {transaction?.orderDetail?.disbursmentPricing && (
            <Card
              className="shadow-sm text-center mb-3"
              style={{
                backgroundColor: '#ECFAFF',
                border: '1px solid #8ABBCC !important',
              }}
            >
              <CardBody>
                <h6 className="fw-semibold">
                  Pembayaran{' '}
                  {Number(transaction?.orderDetail?.disbursmentPricing?.fee) ===
                    0
                    ? transaction?.orderDetail?.disbursmentPricing?.title
                    : `Instan ${transaction?.orderDetail?.disbursmentPricing?.title}`}
                </h6>
                <p>
                  {transaction?.orderDetail?.disbursmentPricing?.description ??
                    '-'}
                </p>
              </CardBody>
            </Card>
          )}
          {/* END INFO PEMBAYARAN */}
          {/* LANJUT PEMBAYARAN */}
          {isShowCardPaymentandReject &&
            ownerData?.userId == transaction?.buyerDetail?.userId && (
              <Card
                className="shadow-sm text-center mb-3"
                style={{
                  backgroundColor: '#ECFAFF',
                  border: '1px solid #8ABBCC !important',
                }}
              >
                <CardBody>
                  <p>Lakukan pembayaran untuk melanjutkan transaksi</p>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    {isSellerShowCard && (
                      <Button
                        outline
                        color="primary"
                        size="sm"
                        style={{ flex: 1 }}
                        onClick={() => onHandleOpenCloseModalReject()}
                        className="btn-cancel"
                      >
                        Tolak
                      </Button>
                    )}

                    <CustomButton
                      block
                      color="primary"
                      size="sm"
                      style={{ flex: 1 }}
                      onClick={() => {
                        const rawItems =
                          transaction?.itemDetail ||
                          transaction?.items ||
                          data?.itemDetail ||
                          data?.items ||
                          []

                        const extractLeafItems = (source) => {
                          if (!Array.isArray(source)) return []
                          const result = []
                          for (const node of source) {
                            if (node?.groupLabel && Array.isArray(node?.items)) {
                              result.push(...extractLeafItems(node.items))
                            } else if (Array.isArray(node?.itemDetail)) {
                              result.push(...extractLeafItems(node.itemDetail))
                            } else if (Array.isArray(node?.items)) {
                              result.push(...extractLeafItems(node.items))
                            } else {
                              result.push(node)
                            }
                          }
                          return result
                        }

                        const leafItems = extractLeafItems(rawItems)

                        const getAdj = (item) => {
                          const topAdjustments =
                            transaction?.adjustments?.adjustmentitems ||
                            transaction?.adjustment?.adjustmentitems ||
                            transaction?.adjustmentitems
                          if (Array.isArray(topAdjustments) && topAdjustments.length > 0) {
                            const matched = topAdjustments.find(
                              (adj) =>
                                Number(adj.orderitemId) === Number(item?.orderitemId ?? item?.id) ||
                                Number(adj.id) === Number(item?.orderitemId ?? item?.id) ||
                                Number(adj.orderitemId) === Number(item?.id),
                            )
                            if (matched) return matched
                          }

                          return (
                            item?.adjustmentitem ||
                            item?.adjustmentItem ||
                            (Array.isArray(item?.adjustmentitems)
                              ? item.adjustmentitems[0]
                              : item?.adjustmentitems)
                          )
                        }

                        const dataComodities = leafItems.map((i) => {
                          const adj = isAdjustment ? getAdj(i) : null

                          const price = adj?.newPrice ?? i.price
                          const quantity =
                            adj?.newAmount ?? adj?.newQuantity ?? i.amount ?? i.quantity
                          const totalPrice =
                            adj?.newTotalPrice ??
                            i.totalPrice ??
                            (parseInt(price, 10) * parseInt(quantity, 10))

                          return {
                            comodity: {
                              value: i.id || i.comodityId,
                              label: i.nameItem || i.name || i.comodityName,
                              id: i.id || i.comodityId,
                              img: i.imageUrl || i.img || i.linkFoto,
                              sku: i.SKU || i.sku,
                              agencyModel: i.agencyModel,
                            },
                            totalPrice: Number(totalPrice) || 0,
                            quantity: Number(quantity) || 0,
                            unit: {
                              value: typeof i.unit === 'object' ? i.unit?.value : i.unit,
                              label: typeof i.unit === 'object' ? i.unit?.label : i.unit,
                            },
                            price: Number(price) || 0,
                          }
                        })

                        localStorage.setItem(
                          'userData',
                          JSON.stringify({
                            dataComodities: dataComodities,
                            dataSeller: transaction?.sellerDetail,
                            talangin: balance?.talangin,
                            wallet1: balance?.uangBelanja,
                            wallet2: balance?.uangUsaha,
                            trxId: transaction?.id,
                          }),
                        )

                        dispatch(
                          setTotal(
                            dataComodities?.reduce(
                              (sum, a) => sum + (a.totalPrice || 0),
                              0,
                            ),
                          ),
                        )

                        navigate('/transaksi-pembelian-pembayaran', {
                          state: {
                            type: 'buyFromSell',
                          },
                        })
                      }}
                    >
                      Lanjut Pembayaran
                    </CustomButton>
                  </div>
                </CardBody>
              </Card>
            )}
          {/* END LANJUT PEMBAYARAN */}

          {/* KONFIRMASI PESANAN */}
          {canBuyerConfirmArrival && (
              <Card
                className="shadow-sm text-center mb-3"
                style={{
                  backgroundColor: '#ECFAFF',
                  border: '1px solid #8ABBCC !important',
                }}
              >
                <CardBody>
                  <p className={isMustAdjustment ? 'text-danger fw-semibold' : ''}>
                    {isMustAdjustment
                      ? 'Anda harus melakukan penyesuaian pesanan dan tidak dapat menyelesaikan transaksi'
                      : 'Pesanan Anda sedang diproses oleh penjual'}
                  </p>
                  <div className="text-start mb-2">
                    <label className="fw-500 mb-1">
                      Gudang tujuan <span className="text-danger">*</span>
                    </label>
                    <PMBSelect
                      value={selectedWarehouse}
                      onChange={setToWarehouse}
                      options={warehouseOptions}
                      isLoading={isFetchingWarehouses}
                      isDisabled={isLoadingCashPayment || isMustAdjustment}
                      placeholder="Pilih gudang"
                      testId="detail-transaction-select-to-warehouse"
                      menuPortalTarget={null}
                    />
                  </div>
                  <Button
                    disabled={
                      isLoadingCashPayment ||
                      isMustAdjustment ||
                      isFetchingWarehouses ||
                      !selectedWarehouse
                    }
                    color="primary"
                    className="w-100 mb-2"
                    onClick={
                      serviceProvision?.transactionProof
                        ? togglePayment
                        : transaction?.orderDetail?.useProofOfPayment &&
                          !transaction?.orderDetail?.paymentTime
                          ? handleConfirmCashPayment
                          : togglePayment
                    }
                  >
                    <Check size={18} />
                    <span style={{ marginLeft: '4px' }}>
                      Konfirmasi Barang Sampai
                    </span>
                  </Button>

                  {transactionAdjustmentData?.adjustment?.status !==
                    'APPROVED' && (
                      <Button
                        color="primary"
                        outline
                        className="w-100 button-hover-effect"
                        // onClick={onHandleOpenCloseModalConfirmAdjustment}
                        onClick={() => {
                          navigate(URL_ORDER_ADJUSTMENT, {
                            state: {
                              escrowpaymentId,
                              ownerPhoneNumber,
                              TransactionType: transactionType,
                              imageUser: isBuyer
                                ? transaction?.sellerOrBuyAvatar
                                : transaction?.sellerOrBuyAvatar,
                              sellerName: isBuyer
                                ? transaction?.sellerDetail?.fullName
                                : transaction?.buyerDetail?.fullName,
                              isAdjustBySeller,
                              adjustFufilmentData:
                                adjustmentBySellerData?.adjustmentitems?.length &&
                                  !transactionAdjustmentData?.adjustment?.status !==
                                  'APPROVED'
                                  ? adjustmentBySellerData?.adjustmentitems
                                  : null,
                            },
                          })
                        }}
                        style={{
                          backgroundColor: '#FFFFFF',
                        }}
                      >
                        <Edit size={16} />
                        <span style={{ marginLeft: '4px' }}>
                          Penyesuaian Pesanan
                        </span>
                      </Button>
                    )}
                </CardBody>
              </Card>
            )}
          {/* END KONFIRMASI PESANAN */}

          {/* KONFIRMASI PEMBAYARAN PEMBELI (COD) */}
          {showSellerConfirmPaymentButton && (
            <Card
              className="shadow-sm text-center mb-3"
              style={{
                backgroundColor: '#ECFAFF',
                border: '1px solid #8ABBCC !important',
              }}
            >
              <CardBody>
                <p>Pesanan telah dibayar oleh pembeli</p>

                <CustomButton
                  block
                  color="primary"
                  size="sm"
                  style={{ flex: 1 }}
                  onClick={() => setIsModalSellerConfirmPayment(true)}
                  disabled={isLoadingSellerConfirmPayment}
                >
                  <Check size={18} />
                  <span style={{ marginLeft: '4px' }}>
                    Konfirmasi Pembayaran Pembeli
                  </span>
                </CustomButton>
              </CardBody>
            </Card>
          )}
          <ModalSellerConfirmPayment
            isOpen={isModalSellerConfirmPayment}
            toggle={() => setIsModalSellerConfirmPayment(false)}
            onConfirm={handleSellerConfirmPayment}
            isLoading={isLoadingSellerConfirmPayment}
          />
          {/* END KONFIRMASI PEMBAYARAN PEMBELI */}

          {/* PEMBAYARAN ATAS NAMA PEMBELI */}
          {transaction?.sellerContinuePayment?.allowed && (
            <Card
              className="shadow-sm text-center mb-3"
              style={{
                backgroundColor: '#ECFAFF',
                border: '1px solid #8ABBCC !important',
              }}
            >
              <CardBody>
                <p>
                  Lakukan pembayaran atas nama pembeli untuk melanjutkan transaksi
                </p>
                <Button
                  disabled={isLoadingSellerPayment}
                  color="primary"
                  className="w-100"
                  onClick={() => setIsModalSellerPayment(true)}
                >
                  <Check size={18} />
                  <span style={{ marginLeft: '4px' }}>
                    Pembayaran Atas Nama Pembeli
                  </span>
                </Button>
              </CardBody>
            </Card>
          )}
          {/* END PEMBAYARAN ATAS NAMA PEMBELI */}
          {(transaction?.approvedAt !== null ||
            shouldShowSellerConfirmOnBehalfCard) &&
            transaction?.status !== 'Menunggu Proses Penjual' &&
            transaction?.status !== 'Ditolak' &&
            transaction?.status !== 'Dibatalkan' &&
            transaction?.status !== 'Menunggu Pembayaran Pembeli' &&
            transaction?.status?.toLowerCase() !== 'expired' ? (
            <Card
              className="shadow-sm text-center mb-3"
              style={{
                backgroundColor: '#ECFAFF',
                border: '1px solid #8ABBCC !important',
              }}
            >
              <CardBody>
                {shouldShowSellerConfirmOnBehalfCard &&
                  transaction?.status !== 'Selesai' ? (
                  <p className={isMustAdjustment ? 'text-danger fw-semibold' : ''}>
                    {isMustAdjustment
                      ? 'Anda harus melakukan penyesuaian pesanan dan tidak dapat menyelesaikan transaksi'
                      : 'Pesanan pembeli sedang diproses oleh penjual (Anda)'}
                  </p>
                ) : transaction?.approvedAt !== null ? (
                  <p>Cetak QR untuk memudahkan pencarian barang</p>
                ) : null}
                {shouldShowSellerConfirmOnBehalfCard &&
                  transaction?.status !== 'Selesai' && (
                    <>
                      <Button
                        disabled={isMustAdjustment}
                        color="primary"
                        className="w-100"
                        onClick={() => setShowConfirmTransactionBySeller(true)}
                      >
                        <Check size={18} />
                        <span style={{ marginLeft: '4px' }}>
                          Konfirmasi Atas Nama Pembeli
                        </span>
                      </Button>
                      {!transactionAdjustmentData?.adjustment ||
                        transactionAdjustmentData?.adjustment?.status ===
                        'REJECTED' ? (
                        <Button
                          color="primary"
                          outline
                          className="w-100 button-hover-effect mt-2"
                          onClick={() => {
                            setIsAdjustBySeller(true)
                            navigate(URL_ORDER_ADJUSTMENT, {
                              state: {
                                escrowpaymentId,
                                ownerPhoneNumber,
                                TransactionType: transactionType,
                                imageUser: isBuyer
                                  ? transaction?.sellerOrBuyAvatar
                                  : transaction?.sellerOrBuyAvatar,
                                sellerName: isBuyer
                                  ? transaction?.sellerDetail?.fullName
                                  : transaction?.buyerDetail?.fullName,
                                isAdjustBySeller: true, // This is Adjustment by seller
                                adjustFufilmentData:
                                  adjustmentBySellerData?.adjustmentitems
                                    ?.length &&
                                    !transactionAdjustmentData?.adjustment
                                      ?.status !== 'APPROVED'
                                    ? adjustmentBySellerData?.adjustmentitems
                                    : null,
                              },
                            })
                          }}
                          style={{
                            backgroundColor: '#FFFFFF',
                          }}
                        >
                          <Edit size={16} />
                          <span style={{ marginLeft: '4px' }}>
                            Penyesuaian Pesanan
                          </span>
                        </Button>
                      ) : null}
                    </>
                  )}
                {transaction?.approvedAt !== null && (
                  <Button
                    color="primary"
                    outline
                    className={`w-100 button-hover-effect ${!isBuyer && serviceProvision?.confirmOnBehalfBuyer ? 'mt-2' : ''}`}
                    onClick={() => {
                      navigate(
                        `${URL_TRANSACTION_QR_PRINT.replace(
                          ':id',
                          transaction?.id || id,
                        )}${location.search || ''}`,
                        {
                          state: {
                            escrowpaymentId:
                              transaction?.escrowpaymentId ||
                              dataState?.escrowpaymentId,
                            tradeshortcutId:
                              transaction?.tradeshortcutId ||
                              tradeshortcutId ||
                              dataState?.tradeshortcutId,
                            transaction,
                          },
                        },
                      )
                    }}
                    style={{
                      backgroundColor: '#FFFFFF',
                    }}
                  >
                    <Printer size={16} />
                    <span style={{ marginLeft: '4px' }}>Print QR</span>
                  </Button>
                )}
              </CardBody>
            </Card>
          ) : null}

          {/* CHANGE PAYMENT */}
          {transaction?.changeInstantPayment && (
            <Card
              className="shadow-sm text-center mb-3"
              style={{
                backgroundColor: '#ECFAFF',
                border: '1px solid #8ABBCC !important',
              }}
            >
              <CardBody>
                {/* <p>Pesanan Anda sedang diproses oleh penjual</p> */}
                <Button
                  color="primary"
                  className="w-100"
                  onClick={() => {
                    setIsChangeInstantPayment(true)
                    setIsModalPayment((prev) => !prev)
                  }}
                >
                  <img src={ZapIcon} alt="Zap Icon" />
                  <span style={{ marginLeft: '4px' }}>
                    Percepat Pengiriman Pembayaran
                  </span>
                </Button>
              </CardBody>
            </Card>
          )}
          {/* END CHANGE PAYMENT */}

          {/* INFORMASI TRANSAKSI */}
          <TransactionInformation
            transaction={transaction}
            transactionNoteData={transactionNoteData}
            isBuyer={isBuyer}
            isCreator={isCreator}
            ownerUserId={ownerUserId}
            sellerUserId={sellerUserId}
            buyerUserId={buyerUserId}
            toggleNoteModal={toggleNoteModal}
            setIsNoteModalOpenEdit={setIsNoteModalOpenEdit}
          />
          {/* END INFORMASI TRANSAKSI */}

          {/* INFORMASI LAINNYA (collapsible) */}
          {transaction?.escrowpayment?.expiredDate && (
            <Card className="shadow-sm border-0 mb-3">
              <CardBody className="py-2 px-3">
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{ cursor: 'pointer' }}
                  onClick={() => setIsOtherInfoOpen((prev) => !prev)}
                >
                  <h6 className="fw-semibold mb-0 text-sm">
                    Informasi lainnya
                  </h6>
                  {isOtherInfoOpen ? (
                    <ChevronUp size={18} className="text-secondary" />
                  ) : (
                    <ChevronDown size={18} className="text-secondary" />
                  )}
                </div>
                <Collapse isOpen={isOtherInfoOpen}>
                  <div className="pt-3">
                    <Row className="mb-2">
                      <Col xs="6" className="fw-light text-sm">
                        Tanggal kedaluwarsa
                      </Col>
                      <Col xs="6" className="fw-semibold text-sm">
                        {PMBFormatDate(
                          transaction.escrowpayment.expiredDate,
                        ) ?? '-'}
                      </Col>
                    </Row>
                  </div>
                </Collapse>
              </CardBody>
            </Card>
          )}
          {/* END INFORMASI LAINNYA */}

          {/* DOKUMEN UNDUH */}
          <DownloadDocumentsSection
            transaction={transaction}
            isBuyer={isBuyer}
            useTalangin={transaction?.creditRequested}
            paymentMethod={paymentMethod}
            refetch={refetchTransactionById}
            isAdjustment={isAdjustment}
            adjustmentitems={
              mergedTransactionAdjustmentData?.adjustment?.adjustmentitems || []
            }
          />
          {/* END DOKUMEN UNDUH */}

          {/* LAPORAN KETELUSURAN ISLAND */}
          <LaporanKetelusuranSection
            transaction={transaction}
            isBuyer={isBuyer}
          />

          {/* ALUR TRANSAKSI */}
          <HistoryTransactionSection
            transaction={transaction}
            isAdjustBySeller={isSellerAdjustmentTimeline}
            isConfirmOnBehalfBuyer={isConfirmOnBehalfBuyer}
            onOpenOriginalOrderModal={() => setIsModalOriginalOrderOpen(true)}
            onOpenFulfillmentModal={() => setIsModalFulfillmentOpen(true)}
          />
          {/* END ALUR TRANSAKSI */}
        </Col>
        {/* END LEFT COLUMN  */}

        {/* RIGHT COLUMN */}
        <Col md="7">
          {/* RINCIAN PESANAN */}
          <DetailOrderSection
            transaction={transaction}
            setIsOpenSidebar={setIsOpenSidebar}
            isAdjustment={
              mergedTransactionAdjustmentData?.adjustment?.adjustmentitems
                ?.length ||
              (isAdjustment &&
                (isDispute ||
                  transactionAdjustmentData?.adjustment?.status === 'APPROVED'))
            }
            isStatusAdjustmentRejected={isStatusAdjustmentRejected}
            transactionAdjustmentData={mergedTransactionAdjustmentData}
            shouldHighlightAdjustedValues={shouldHighlightAdjustedValues}
            shouldShowSellerAdjustmentWarning={
              shouldShowSellerAdjustmentWarning
            }
            isCreator={isCreator}
            // inventory only belongs to the buyer once the transaction is done
            canOpenInventory={isBuyer && transaction?.status === 'Selesai'}
          />
          {/* END RINCIAN PESANAN */}
        </Col>
        {/* END RIGHT COLUMN */}
      </Row>
    </div>
  )
}

export default DetailTransaction
